// Fase 4 · Traducción de los datos de los sobres V2 a lo que esperan los
// reducers existentes. Sin dependencias para poder testearlo.

/** Mesa "slim" del evento fusionada sobre la del store (no perder campos). */
export function mergeSlimMesa(existing, slim) {
  if (!slim) return existing;
  return existing ? { ...existing, ...slim } : slim;
}

/** Convierte `products.changed` al formato que entiende planProductHubRefresh. */
export function productEventsFromEnvelope(data) {
  if (!data || data.bulk) return [{ action: "bulk" }];
  const ids = Array.isArray(data.productoIds) ? data.productoIds : [];
  if (ids.length === 0) return [{ action: data.action || null }];
  return ids.map((productoId) => ({ productoId, action: data.action || "updated" }));
}

/**
 * Pedidos (hub V2, eventos slim sin productos). Decide si hay que refrescar
 * la lista `order.onlyOrders` (antes la alimentaba `addPedido` con el DTO
 * completo del hub legacy `pedido/{rid}`).
 *  - Solo si la lista está en uso (cargada o estamos en el TPV grande).
 *  - `pedido.created` → siempre.
 *  - `pedido.changed` → si el pedido está en la lista y cambia `approved` o
 *    `pendingPayment`, o si no está (llegó sin verse el created).
 *  - `pedido.ready` → no afecta a la lista.
 */
export function shouldRefetchOrdersList(type, data, { onlyOrders, listInUse } = {}) {
  if (!listInUse) return false;
  if (type === "pedido.created") return true;
  if (type !== "pedido.changed") return false;
  const id = data?.id;
  if (id == null) return false;
  const current = (onlyOrders || []).find((o) => String(o?.id) === String(id));
  if (!current) return true;
  const changed = (field) =>
    data[field] !== undefined && Boolean(data[field]) !== Boolean(current[field]);
  return changed("approved") || changed("pendingPayment");
}

/**
 * Ejecuta `fn` como mucho una vez por ventana: la primera llamada programa la
 * ejecución tras `delayMs`; las siguientes dentro de la ventana se agrupan.
 * Si llega otra mientras `fn` (promesa) está en curso, se programa UNA más al
 * terminar (no se pierden cambios).
 */
export function createCoalescedRunner(fn, delayMs = 500) {
  let timer = null;
  let inFlight = false;
  let pending = false;
  const run = async () => {
    timer = null;
    inFlight = true;
    try {
      await fn();
    } catch (_) {
      // el propio fn gestiona errores
    } finally {
      inFlight = false;
      if (pending) {
        pending = false;
        schedule();
      }
    }
  };
  const schedule = () => {
    if (inFlight) {
      pending = true;
      return;
    }
    if (!timer) timer = setTimeout(run, delayMs);
  };
  return schedule;
}
